import { Box, Image } from "@chakra-ui/react";
import React, { useMemo } from "react";
import { COMMON_WEB_PATH } from "../../constant";

/**
 *
 * @description 遊戲圖片標籤(爆,新,熱,獨)
 */
const GameImageTag = ({ game_tags_props = [] } = {}) => {
  const game_img_tags = useMemo(() => {
    const filter_img_tags = game_tags_props?.filter((tag) => {
      return tag?.includes("IMG_");
    });

    if (filter_img_tags?.length === 0) return null;

    const img_tags = filter_img_tags[0];

    const split_tag = img_tags?.split("_");
    const tag_name = split_tag?.[1]?.toLowerCase();

    return tag_name;
  }, [game_tags_props]);

  /**
   * @description 根據個別標籤做不同的樣式
   */
  const tagCustomStyle = useMemo(() => {
    switch (game_img_tags) {
      case "hot":
        return {
          wrapperClass: {
            top: "-10%",
            left: "-4px",
            w: "30%",
            // h: "30%",
            maxW: "50px",
            maxH: "50px",
          },
          imageClass: {
            objectFit: "contain",
          },
        };
      default:
        return {
          wrapperClass: {},
        };
    }
  }, [game_img_tags]);

  return (
    game_img_tags && (
      <Box
        position="absolute"
        top="-5px"
        left="-5px"
        zIndex="99"
        w="24%"
        // h="24%"
        aspectRatio={"1 / 1"}
        maxW="45px"
        maxH="45px"
        {...tagCustomStyle.wrapperClass}
      >
        <Image
          src={`${COMMON_WEB_PATH}/911TW/tags/img_${game_img_tags}_tag.png`}
          alt={game_img_tags}
          w={"100%"}
          h={"100%"}
          objectFit="cover"
          {...tagCustomStyle.imageClass}
        />
      </Box>
    )
  );
};

export default GameImageTag;
